// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ink-900: #0a1628;
  --ink-800: #101f38;
  --ink-700: #132b4d;
  --ink-600: #1c3a63;
  --brass: #c6a15b;
  --brass-soft: #e3c98a;
  --ivory: #fbf9f4;
  --ivory-dim: #f1ede2;
  --slate: #48546b;
  --slate-soft: #8792a6;
  --emerald: #2f6f5e;
  --danger: #b3432b;
  --border-warm: #e3ddcd;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ink-900);
  background: var(--ivory);
}

h1, h2, h3 {
  font-family: 'Fraunces', Georgia, serif;
}

code {
  font-family: 'IBM Plex Mono', source-code-pro, Menlo, Monaco, Consolas,
    'Courier New', monospace;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;iEAC+D;EAC/D,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;4BAC0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB","sourcesContent":[":root {\n  --ink-900: #0a1628;\n  --ink-800: #101f38;\n  --ink-700: #132b4d;\n  --ink-600: #1c3a63;\n  --brass: #c6a15b;\n  --brass-soft: #e3c98a;\n  --ivory: #fbf9f4;\n  --ivory-dim: #f1ede2;\n  --slate: #48546b;\n  --slate-soft: #8792a6;\n  --emerald: #2f6f5e;\n  --danger: #b3432b;\n  --border-warm: #e3ddcd;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--ink-900);\n  background: var(--ivory);\n}\n\nh1, h2, h3 {\n  font-family: 'Fraunces', Georgia, serif;\n}\n\ncode {\n  font-family: 'IBM Plex Mono', source-code-pro, Menlo, Monaco, Consolas,\n    'Courier New', monospace;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
